import {
  Field,
  SelectionField,
  TextField,
  TogglerField,
} from 'modules/marketplace/hooks/integrations/formQuestions/useGetMarketplaceSettings'

import { SelectionQuestion } from './Questions/SelectionQuestion'
import { TextQuestion } from './Questions/TextQuestion'
import { TogglerQuestion } from './Questions/TogglerQuestion'

export interface DynamicFieldFormProps {
  field: Field
  key: number | string
  value?: string | string[] | number | boolean
  onChange: (value: string | string[] | boolean) => void
}

const DynamicFieldForm: React.FC<DynamicFieldFormProps> = ({ field, value, onChange }) => {
  switch (field.type) {
    case 'text':
      return (
        <TextQuestion
          // eslint-disable-next-line no-type-assertion/no-type-assertion
          textQuestion={field as TextField}
          // eslint-disable-next-line no-type-assertion/no-type-assertion
          currentValue={value ? (value as string) : undefined}
          onChange={onChange}
        />
      )
    case 'selection':
      return (
        <SelectionQuestion
          // eslint-disable-next-line no-type-assertion/no-type-assertion
          selectionQuestion={field as SelectionField}
          // eslint-disable-next-line no-type-assertion/no-type-assertion
          currentValue={value ? (value as string) : undefined}
          onChange={onChange}
        />
      )
    case 'toggler':
      return (
        <TogglerQuestion
          // eslint-disable-next-line no-type-assertion/no-type-assertion
          togglerQuestion={field as TogglerField}
          // eslint-disable-next-line no-type-assertion/no-type-assertion
          currentValue={value ? (value as boolean) : undefined}
          onChange={onChange}
        />
      )
  }
}

export default DynamicFieldForm
